// extracted by mini-css-extract-plugin
export var addressFields = "_mo-0";
export var animationContainer = "_mo-1";
export var footer = "_mo-2";
export var lineItems = "_mo-3";
export var modalContent = "_mo-4";
export var orderName = "_mo-5";
export var strong = "_mo-6";
export var warning = "_mo-7";